<fieldset [formGroup]="optionGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="optionFunctionalElement$; let optionFunctionalElement">
        <div class="row">
            <p class="col" [innerHTML]="optionFunctionalElement.label"></p>
        </div>
        <div class="row mb-3 justify-content-between">
            <div class="col-auto col-sm-7 d-flex flex-column flex-sm-row gap-2">
                <span class="options">
                    <label>
                        <!-- according to spec, the usual meaning of RADIOBTN.VALUE1 = 'yes' and RADIOBTN.VALUE2 = 'no' is
                        inverted for OPTION and RADIOBTN.VALUE1 means 'no' and RADIOBTN.VALUE2 means 'yes'. -->
                        <input
                            type="radio"
                            class="form-check-input"
                            [value]="OPTION_FUNCTIONAL_ELEMENT_TYPE.YES"
                            [checked]="optionFunctionalElement.selected === OPTION_FUNCTIONAL_ELEMENT_TYPE.YES"
                            formControlName="radio"
                        />
                        {{ optionFunctionalElement.yesLabel }}
                    </label>
                </span>
                <span class="options">
                    <label>
                        <!-- according to spec, the usual meaning of RADIOBTN.VALUE1 = 'yes' and RADIOBTN.VALUE2 = 'no' is
                        inverted for OPTION and RADIOBTN.VALUE1 means 'no' and RADIOBTN.VALUE2 means 'yes'. -->
                        <input
                            type="radio"
                            class="form-check-input"
                            [value]="OPTION_FUNCTIONAL_ELEMENT_TYPE.NO"
                            [checked]="optionFunctionalElement.selected === OPTION_FUNCTIONAL_ELEMENT_TYPE.NO"
                            formControlName="radio"
                        />
                        {{ optionFunctionalElement.noLabel }}
                    </label>
                </span>
            </div>
            <div class="col-auto col-sm-5 align-self-end pe-0">
                <button
                    class="btn btn-link"
                    *ngIf="(readOnly$ | async) === false"
                    (click)="reset()"
                    translate="OPTION_RESET_BUTTON_LABEL"
                ></button>
            </div>
        </div>
    </ng-container>
</fieldset>
